import React from 'react';

function SectionSplit () {
    return (
        <div className="section-split"></div>
    )
}

export default SectionSplit